export const difficulty = (Level: number): number[] => {
  switch (Level) {
    case 1:
      return [11, 25]

    case 2:
      return [25, 70]

    case 3:
      return [70, 99]

    default:
      return [11, 99]
  }
}
